import { ChatCardPropsType } from "./ChatCard";
import { Typography } from "@material-tailwind/react";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { markdownComponents } from "../../thoughts/chat/RenderResponse";

export const RenderResponse = ({ isLoading, response, feed_back }: ChatCardPropsType) => {
    if (isLoading) {
        return (
            <div className="max-w-full animate-pulse">
                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-11/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-10/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-2/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
                <Typography as="div" variant="paragraph" className="mb-2 h-2 w-6/12 rounded-full bg-gray-400">
                    &nbsp;
                </Typography>
            </div>
        );
    } else if (typeof response === "string") {
        return (
            <div>
                <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]} components={markdownComponents}>
                    {response}
                </ReactMarkdown>
            </div>
        );
    }

    return null;
};
